module.exports = __webpack_public_path__ + "static/SATMANLogo-c12c43f807504558d189c1cba0aa5bf4.png";